import * as React from 'react';
import { INewPurchaseOrderDialogProps } from './NewPurchaseOrderDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import NewPurchaseOrderForm from './NewPurchaseOrderDialog.form';
import { useCreatePurchaseOrder } from 'api/purchaseOrders/purchaseOrders';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';

const STYLE_PROPS = {
  height: '460px',
  minWidth: '450px'
} as const;

const NewPurchaseOrderDialog = (props: INewPurchaseOrderDialogProps): JSX.Element => {
  const { open, onClose, values, initialValues, valuesSchema, currentUserId, currentWarehouse, changeFormFieldValue, searchById, resetFastEntry, formSyncErrors } = props;
  const { mutateAsync: createPurchaseOrderMutateAsync, isLoading: isProcessing } = useCreatePurchaseOrder();
  const [isValidPO, setIsValidPO] = React.useState<boolean>(false);
  const [isValidSupplier, setIsValidSupplier] = React.useState<boolean>(false);
  const userIdFieldRef = React.useRef<IBasicLookupFieldHandle>();

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Ok',
        isDefault: true,
        disabled: isProcessing,
        listener: async () => {
          if (values?.SupplierId && values?.Warehouse && values?.UserId) {
            if (values?.LoadFromPurchaseOrder && isValidPO || !values?.LoadFromPurchaseOrder) {
              const response = await createPurchaseOrderMutateAsync({
                ...values,
                SupplierId: Number(values?.SupplierId),
                UserId: Number(values?.UserId)
              });

              if (response?.Status) {
                searchById(response?.LoadPurchaseOrderResult?.PurchaseOrder?.Value);
                resetFastEntry();
                onClose();
              }
            }
          } else if (values?.SupplierId && values?.Warehouse && Object.keys(formSyncErrors).includes('UserId')) {
            setTimeout(
              () => {
                userIdFieldRef.current?.focus();
              },
              0
            );
          }
        }
      },
      {
        title: 'Cancel',
        listener: () => {
          onClose();
        }
      }
    ];
  };

  return (<FormViewModal
    open={open}
    loading={false}
    title='New Purchase Order'
    formProps={{
      style: STYLE_PROPS,
      formSchema: NewPurchaseOrderForm,
      supplierId: values?.SupplierId ? Number(values.SupplierId) : undefined,
      initialValues: {
        ...initialValues,
        UserId: currentUserId,
        Warehouse: currentWarehouse
      } || {},
      valuesSchema: valuesSchema,
      fieldExtensions: (
        {
          SupplierId: {
            onSelectedItemChange: (value: any) => {
              setIsValidSupplier(!!value?.Code);
            }
          },
          LoadFromPurchaseOrder: {
            disabled: !(values?.SupplierId && isValidSupplier),
            onSelectedItemChange: (value: any) => {
              const isValid = !!value?.Code;

              setIsValidPO(isValid);
              changeFormFieldValue('LoadNotesAndComments', isValid);
              changeFormFieldValue('LoadProducts', isValid);
            }
          },
          LoadNotesAndComments: {
            disabled: !(values?.LoadFromPurchaseOrder && isValidPO),
          },
          LoadProducts: {
            disabled: !(values?.LoadFromPurchaseOrder && isValidPO),
          },
          UserId: {
            fieldRef: (Ref) => userIdFieldRef.current = Ref,
          }
        }
      )
    }}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}

  />);
};

export default NewPurchaseOrderDialog;
